module.exports = __webpack_public_path__ + "assets/img/1_1558_big.cdd3e17a.jpg";